export enum SelectionEnum {
  All = "All",
  None = "None",
  Some = "Some",
}
